import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=17055808"
var script = {}
import style0 from "./heading.vue?vue&type=style&index=0&id=17055808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports